export const AUTO_TEST_URL = 'AUTO_TEST_URL';
